import React from "react";

import clsx from "clsx";

import { RowVirtualizerDynamic } from "@components/virtualized-list";
import { Card } from "@shared/card";

import { type CustomerTouchpoint, JourneyCard } from "./JourneyCard";

export type CustomerJourneyProps = {
  touchpoints: CustomerTouchpoint[];
  isUnknownTouchpoints: boolean;
};

export function CustomerJourney({
  touchpoints,
  isUnknownTouchpoints,
}: CustomerJourneyProps) {
  return (
    <div className="ml-7">
      <Card className=" py-3 w-[43rem] rounded-md bg-v2-primary	">
        <div className="flex w-full font-semibold mb-2">
          <div>Journey</div>
          {/* A completed customer journey will always have a purchase (this is not counted in
             the touchpoint though) */}
          <div className="ml-auto">
            {isUnknownTouchpoints
              ? "Touchpoints not available"
              : `${touchpoints.length - 1} Touchpoints`}
          </div>
        </div>
        <div className="h-[43rem] overflow-auto">
          {touchpoints.length <= 1 && !isUnknownTouchpoints && (
            <div
              key="customer-journey-no-touchpoint"
              className={clsx(
                "rounded-md bg-[#F2F3F4] mb-2 h-[6.313rem]",
                "flex items-center	justify-center",
              )}
            >
              <div>
                <div className="flex flex-row mb-3 ">
                  We were unable to detect the touchpoints of this order.
                </div>
              </div>
            </div>
          )}
          <RowVirtualizerDynamic rows={touchpoints} Row={Row} />
        </div>
      </Card>
    </div>
  );
}

function Row({
  index,
  row,
  totalCount,
}: {
  index: number;
  row: CustomerTouchpoint;
  totalCount: number;
}) {
  return (
    <div
      className={index - 1 !== totalCount ? "mb-2" : undefined}
      key={`customer-journey-touchpoint-${index}`}
    >
      <JourneyCard touchpoint={row} />
    </div>
  );
}
